import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import querystring from 'querystring';
import { Redirect } from 'react-router-dom';
import { completeLoginFlow } from './login-thunk';
import {
    selectAuthenticationError,
    selectAsyncStatus,
    selectClientAuthorizedForSkill,
    selectUserAuthenticationStatus,
} from './login-selector';
import { selectAppConfigs } from '../app-config/app-config-selector';
import Routes from '../../constants/routes';
import { hasFailed } from '../../../libs/utils/constants/async-status';

const LoginCallback = () => {
    const dispatch = useDispatch();
    const autheticationError = useSelector(selectAuthenticationError);
    const hasUserSkillAccess = useSelector(selectClientAuthorizedForSkill);
    const isUserAuthenticated = useSelector(selectUserAuthenticationStatus);
    const asyncStatus = useSelector(selectAsyncStatus);
    const appConfig = useSelector(selectAppConfigs);

    useEffect(() => {
        if (isLoginRedirect()) {
            dispatch(completeLoginFlow());
        }
    });
    const isLoginRedirect = () => {
        const queryParams = querystring.decode(
            window.location.search.replace('?', '')
        );
        const isLoginRedirect =
            appConfig.USE_KEYCLOAK === 'true'
                ? Object.values(queryParams).every(
                      (param) => param !== null && param !== ''
                  )
                : Object.keys(queryParams).length === 2 &&
                  queryParams.code !== '' &&
                  queryParams.state !== '';

        return isLoginRedirect;
    };
    return (autheticationError && hasFailed(asyncStatus)) ||
        (isUserAuthenticated && !hasUserSkillAccess) ? (
        <Redirect to={Routes.ERROR_PAGE} />
    ) : null;
};

export default LoginCallback;
